<template>
  <div class="element-insure-item" >
    <div class="cardsection">
      <div class="cardcontainer">

        <template v-if="list.length == 0">
          <div class="card-frame">
            <div class="card noitems">
              <img :src="'../static/info_gray.png'" />
              비교견적 신청내역이 없습니다.<br>
              지금 비교견적을 신청하시겠습니까?
              <button @click="goEstimate">비교견적 신청하기</button>
            </div>
          </div>

        </template>
        <template v-if="list.length > 0 && render">
          <template v-if="$store.state.config.isTouchDevice">
            <carousel :items="1" :nav="false" :dots="true" :margin="11">
              <div class="card" v-for="(item, index) in list" :key="index">
                <RepairItemCard v-bind:item="item" />
                <button @click="goEstimate">정비·수리 비교견적 신청</button>
              </div>
            </carousel>
          </template>
          <template v-else>
            <div class="pc-cardview">
              <div class="card-frame" v-for="(item, index) in list" :key="index">
                <div class="card">
                  <RepairItemCard v-bind:item="item" />
                  <button @click="goEstimate">정비·수리 비교견적 신청</button>
                </div>
              </div>
            </div>
          </template>
        </template>
      </div>
    </div>
  </div>
</template>

<style>
.owl-theme .owl-nav.disabled + .owl-dots {
  margin-top: -1rem !important;
}
.owl-dots .owl-dot {
  width: auto;
}
</style>

<script>
import carousel from 'vue-owl-carousel'

const RepairItemCard = {
  props: {
    item: {
      type: Object,
      required: true
    },
    type: {
      type: String
    }
  },
  data() {
    return {
      profileUrl: `background-image: url('${this.item.manager.profileUrl}')`
    }
  },
  template: `
    <div>
    <router-link :to="{ name: 'RepairDetail', query:{ repairId: item._id }}">
      <div class="section-insure">
        <div class="header">
          <div class="banner">
            <div :class="[{ category: true }]">사고보상</div>
            <div class="type">정비·수리</div>
          </div>
          <div class="title">{{ item.repair_estimate_type }}견적</div>
          <p :class="[{ status3: true }]">{{ item.repair_estimate_status }} </p>
        </div>

        <div class="body">
          <div class="body-item" v-if="item.autocode_name">
            차량정보
            <p>{{ item.autocode_name }}</p>
          </div>

          <div class="body-item" v-if="item.repair_estimate_date">
            접수일
            <p>{{ item.repair_estimate_date }}</p>
          </div>

          <div class="body-item">
            희망지역
            <p>{{ item.desired_area }}</p>
          </div>
        </div>

      </div>
    </router-link>
    <div class="section-manager">
      <div class="circle profile"
           :style="profileUrl"
           style='background-repeat: no-repeat;background-position: center;background-size:cover;'>
      </div>
      <div class="name">
        {{ item.manager.name }}
      </div>
      <div class="circle phone"
           @click="callPhone(item.manager.phone.replace(/(-)/g,''), $event)">
        <img :src="'../static/phone.png'"/>
      </div>
      <div class="circle kakaotalk" @click="openKakao(item.manager.kakaotalk, $event)">
        <img :src="'../static/kakao.png'"/>
      </div>
    </div>
    </div>
  `,
  methods: {
    openKakao(link, event){
      event.preventDefault()
      window.open(link);
    },
    callPhone(link, event){
      event.preventDefault()
      window.open("tel:" + link);
    },
  }
}

export default {
  components: { carousel, RepairItemCard },
  props: [ "value", "data", "type", "tab" ],
  watch: {
    data: function(newVal, oldVal) {
      this.list = newVal;
      this.render = false;
      this.$nextTick(function () {
        this.render = true;
      })
    }
  },
  data() {
    return {
      render: true,
      list: this.data,
    }
  },
  methods: {
    goEstimate () {
      this.$router.push({ name: 'RepairEstimate', query: { customerId: this.$store.state.customer.profile._id } })
    },
    tel(t, e){
      e.preventDefault()
      location.href = "tel:" + t
    },
  }
}
</script>

<style lang="scss">
.btn-routerlink {
  font-weight: bold;
  border-radius: 0px !important;
}
</style>
